import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Growl } from 'primereact/growl';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import Moment from 'react-moment';
import { Dialog } from 'primereact/dialog';
import {Dropdown} from 'primereact/dropdown';


import servicioPaginacion from '../servicios/ServicioPaginacion';
import servicioDescargaArchivos from '../servicios/ServicioDescargaArchivos';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
import servicioCancelacion from '../servicios/ServicioCancelacion';



class CancelacionCfdi extends Component {
  constructor() {
    super();
    this.state = {
      mostrarBotonExcel: false,
      objetoPerfil: {},
      cfdi: {},
      erroresFecha: {},
      errorFolio: {},
      errorSerie: {},
      paginacion: {
        registrosPorPagina: 20,
        clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TrFacturacion',
        join: ["twCfdi"],
        conjunciones: {},
        betweenPropertyName: null,
        between: [],
        session: true,
        mostrarCancelaciones: false,
        modalResultadoCancelacion: false,
        resultadoCfdis: []
      },
      first: 0,
      idUsuario: null,
      cfdicancelados: [],
      mostrarOpcionEstado: { display: 'none' },
      modalCancelar:false,
      motivos: [
        { value: "01", label: "Comprobante emitido con errores con relación" }, 
        { value: "02", label: "Comprobante emitido con errores sin relación" },
        { value: "03", label: "No se llevó a cabo la operación" },
        { value: "04", label: "Operación nominativa relacionada en una factura global" }
    ],
    errores:{},
    cancelacionDto:{}
    }
    this.descargarDetalleExcel = this.descargarDetalleExcel.bind(this);
  }

  componentDidMount() {
    this.obtenerSession();
    this.obtenerNombreUsuario();

  }

  obtenerSession = () => {
    servicioUsuario.usuarioSession().then(response => {
      this.setState({ idUsuario: response.data });
    }).catch(error => {

    });
  }

  obtenerNombreUsuario = () => {
    
    servicioUsuario.nombreDePerfil().then(response => {
      this.setState({ objetoPerfil: response.data });
      if (response.data.nombre.includes("ADMINISTRADOR")) {
        this.setState({ mostrarOpcionEstado: { display: 'block' } });
      }



    }).catch(error => {

    });

  }

  obtenerResultados = () => {
    const { paginacion } = this.state;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }

  onPage = (event) => {
    this.setState({
      first: event.first
    });
    const { paginacion } = this.state;
    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }


  templateDescargaArchivos = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi pi-download" className="p-button-success" onClick={(e) => this.descargaArchivos(rowData)}></Button>
    </div>;
  }

  descargaArchivos = (rowData) => {
    servicioDescargaArchivos.descargaArchivo('documentos/cfdi/descargazip.json', { id: rowData.twCfdi.id });
  }

  validarFormularioFechas = (cfdi) => {
    const errores = {};
    if (!cfdi.fechaCreacion)
      errores.fechaCreacion = "La fecha inicial es requerida";
    if (!cfdi.fechaCertificacion)
      errores.fechaCertificacion = "La fecha final es requerida";
    return errores;
  }

  validarFormularioFolio = (cfdi) => {
    const errores = {};
    if (!cfdi.folio)
      errores.folio = "EL folio es requerido";
    return errores;
  }

  validarFormularioSerie = (cfdi) => {
    const errores = {};
    if (!cfdi.serie)
      errores.serie = "La serie es requerido";
    return errores;
  }

  buscarPorFechas = () => {
    let { paginacion, cfdi, objetoPerfil } = this.state;
    const validacion = this.validarFormularioFechas(cfdi)
    var nombreAdministrador = "ADMINISTRADOR";
    this.setState({ erroresFecha: validacion });
    if (!Object.keys(validacion).length) {
      paginacion.betweenPropertyName = "alias_twCfdi.fechaCertificacion";
      paginacion.between = [cfdi.fechaCreacion.getTime(), cfdi.fechaCertificacion.getTime()];

      paginacion.conjunciones = {};
      if (!objetoPerfil.nombre.includes(nombreAdministrador)) {
        let nombrePropiedad = "alias_twCfdi.tipoDeComprobante";
        paginacion.conjunciones[nombrePropiedad] = "I";
      }
      this.setState({ paginacion: paginacion });
      this.obtenerResultados();
    }
  }

  buscarFolio = () => {
    let { paginacion, cfdi, objetoPerfil } = this.state;
    const validacion = this.validarFormularioFolio(cfdi);
    var nombreAdministrador = "ADMINISTRADOR";
    this.setState({ errorFolio: validacion });
    if (!Object.keys(validacion).length) {
      let nombrePropiedad = "alias_twCfdi.folio";
      paginacion.conjunciones = {};
      paginacion.conjunciones[nombrePropiedad] = cfdi.folio;
      if (!objetoPerfil.nombre.includes(nombreAdministrador)) {
        let nombrePropiedad2 = "alias_twCfdi.tipoDeComprobante";
        paginacion.conjunciones[nombrePropiedad2] = "I";
      }
      this.setState({ paginacion: paginacion });
      this.obtenerResultados();
    }
  }

  buscarSerie = () => {
    let { paginacion, cfdi, objetoPerfil } = this.state;
    const validacion = this.validarFormularioSerie(cfdi);
    var nombreAdministrador = "ADMINISTRADOR";
    this.setState({ errorSerie: validacion });
    if (!Object.keys(validacion).length) {
      let nombrePropiedad = "alias_twCfdi.serie";
      paginacion.conjunciones = {};
      paginacion.conjunciones[nombrePropiedad] = cfdi.serie;
      if (!objetoPerfil.nombre.includes(nombreAdministrador)) {
        let nombrePropiedad2 = "alias_twCfdi.tipoDeComprobante";
        paginacion.conjunciones[nombrePropiedad2] = "I";
      }
      this.setState({ paginacion: paginacion });
      this.obtenerResultados();
    }
  }

  buscarFacturaActivo = () => {
    let { paginacion} = this.state;
    let nombrePropiedad = "alias_twCfdi.estado";
    paginacion.conjunciones = {};
    paginacion.conjunciones[nombrePropiedad] = 1;

    this.setState({ paginacion: paginacion });
    this.obtenerResultados();
  }

  buscarFacturaCancelada = () => {
    let { paginacion } = this.state;
    let nombrePropiedad = "alias_twCfdi.estado";
    paginacion.conjunciones = {};
    paginacion.conjunciones[nombrePropiedad] = 6;

    this.setState({ paginacion: paginacion });
    this.obtenerResultados();
  }

  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
  }

  reinicioVariables = () => {
    const { objetoPerfil } = this.state;
    var nombreAdministrador = "ADMINISTRADOR";
    var nombrePerfil = true;
    if (objetoPerfil.nombre.includes(nombreAdministrador)) {
      nombrePerfil = false;
      this.setState({ mostrarBotonExcel: true });
    }

    this.setState({
      cfdi: {},
      erroresFecha: {},
      paginacion: {
        registrosPorPagina: 20,
        clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TrFacturacion',
        join: ["twCfdi"],
        conjunciones: {},
        betweenPropertyName: null,
        between: [],
        session: nombrePerfil
      },
      first: 0
    });

    this.selectedCheckboxes = new Set();

  }

  formatofechaCreacion = (rowData, column) => {
    return <Moment format="YYYY-MM-DD HH:mm:ss">
      {rowData.twCfdi.fechaCreacion}
    </Moment>;
  }

  formatofechaCertificacion = (rowData, column) => {

    if (!rowData.twCfdi.fechaCertificacion) {
      return "";
    } else {
      return <Moment format="YYYY-MM-DD HH:mm:ss">
        {rowData.twCfdi.fechaCertificacion}
      </Moment>;
    }
  }

  formatofechaCancelacion = (rowData, column) => {
    if (!rowData.twCfdi.fechaCancelacion) {
      return "";
    } else {
      return <Moment format="YYYY-MM-DD HH:mm:ss">
        {rowData.twCfdi.fechaCancelacion}
      </Moment>;
    }
  }

  formatoEstatus = (rowData, column) => {
    if (rowData.twCfdi.estado === 6)
      return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Cancelado</p>;
    else
      return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>
  }

  descargarDetalleExcel() {

    const { cfdi } = this.state;

    if (cfdi.fechaCreacion != null && cfdi.fechaCertificacion != null) {
      cfdi.fechaCreacion = cfdi.fechaCreacion.getTime();
      cfdi.fechaCertificacion = cfdi.fechaCertificacion.getTime();
    }

    servicioDescargaArchivos.descargaArchivo('/documentos/descargaDetalleFacturacion.json', cfdi);
    this.setState({ cfdi: {} });

  }

  actionTemplate = (rowData, column) => {
    if (rowData.twCfdi.estado === 6)
      return "";
    else
      return <div>        
        <Button label={"Cancelar " + rowData.twCfdi.serie +"-"+rowData.twCfdi.folio} className="p-button-rounded p-button-warning" onClick={() => this.mostrarModalCancelacion(rowData)} />
      </div>;
  }

  templateMotivos = (option) => {
    return (
        <div className="p-clearfix">                
            <span>{option.value}-{option.label}</span>
        </div>
    );
}

  mostrarModalCancelacion = (rowData) => {
    let cancelacionDto = {};
    cancelacionDto.id =rowData.twCfdi.id;
    cancelacionDto.uuid = rowData.twCfdi.uuid;
    this.setState({
      errores: {},
      modalCancelar: true,
      cancelacionDto
    });
  }

  validarRegistrosObjetos = (e) => {
    let selectedcfdi = [...this.state.cfdicancelados];

    if (e.checked)
      selectedcfdi.push(e.value);
    else
      selectedcfdi.splice(selectedcfdi.indexOf(e.value), 1);

    if (selectedcfdi.length > 0) {
      this.setState({ cfdicancelados: selectedcfdi, mostrarCancelaciones: true });
    } else {
      this.setState({ cfdicancelados: selectedcfdi, mostrarCancelaciones: false });
    }
  }

  cancelar = () => {
    let { cancelacionDto } = this.state;
    let errores = this.validarFormularioCancelacion(cancelacionDto);
    this.setState({ errores });
    if(servicioAsignacionValoresObjetos.esObjetoVacio(errores)){
      servicioCancelacion.cancelarCfdi(cancelacionDto).then(response => {
        this.setState({ resultadoCfdis: response.data, modalResultadoCancelacion: true, modalCancelar: false,cancelacionDto:{} });
        this.obtenerResultados();
      }).catch(error => {
  
      });
    }
    
  }

  cerrarmodalConfirmacionCancelacion = () => {
    this.setState({ modalResultadoCancelacion: false });
  }

  cerrarModalCancelacion = () => {
    this.setState({ modalCancelar: false, cfdis: [] });
  }

  validarFormularioCancelacion = (cancelacionDto) => {
    let errores = {};
    if (servicioAsignacionValoresObjetos.esObjetoVacio(cancelacionDto.motivo)) {
        errores.motivo = "Debe de elegir un motivo de cancelacion";
    } else {
        if (cancelacionDto.motivo === "01" && servicioAsignacionValoresObjetos.esObjetoVacio(cancelacionDto.folioSustitucion)) {
            errores.folioSustitucion = "Debe de agregar un folio de sustitución para cancelar la factura";
        }
    }
    return errores;
}

  render() {
    const { erroresFecha, cfdi, paginacion, first, errorFolio, errorSerie, modalCancelar
      , resultadoCfdis, mostrarOpcionEstado, cancelacionDto, motivos, errores } = this.state;
    const es = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "Mi", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    };

    const footer = (
      <div>
        <Button label="Aceptar" icon="pi pi-check" onClick={this.cerrarmodalConfirmacionCancelacion} />
      </div>
    );

    return (

      <div>
        <Growl ref={(el) => this.growl = el} />
        <h1>Administración de Cancelación</h1>
        <Accordion onTabOpen={this.reinicioVariables} onTabClose={this.reinicioVariables}>
          <AccordionTab header="Búsqueda por fecha" >
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <h4>*Fecha Inicial:</h4>
                <Calendar id="fechaCreacion" name="cfdi.fechaCreacion" value={cfdi.fechaCreacion || ''} onChange={this.asignarValoresObjeto} className={erroresFecha.fechaCreacion ? 'p-error' : ''} locale={es} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
                {erroresFecha.fechaCreacion ? <div><br /> <Message severity="error" text={erroresFecha.fechaCreacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <h4>*Fecha Final:</h4>
                <Calendar id="fechaCertificacion" name="cfdi.fechaCertificacion" value={cfdi.fechaCertificacion || ''} onChange={this.asignarValoresObjeto} className={erroresFecha.fechaCertificacion ? 'p-error' : ''} locale={es} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
                {erroresFecha.fechaCertificacion ? <div><br /> <Message severity="error" text={erroresFecha.fechaCertificacion} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarPorFechas} />
              </div>




            </div>
          </AccordionTab>
          <AccordionTab header="Búsqueda por folio">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <h4>*Folio:</h4>
                <InputText id="folio" name="cfdi.folio" value={cfdi.folio || ''} onChange={this.asignarValoresObjeto} className={errorFolio.folio ? 'p-error' : ''} />
                {erroresFecha.folio ? <div><br /> <Message severity="error" text={erroresFecha.folio} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarFolio} />
              </div>
            </div>
          </AccordionTab>
          <AccordionTab header="Búsqueda por serie">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <h4>*Serie:</h4>
                <InputText id="serie" name="cfdi.serie" value={cfdi.serie || ''} onChange={this.asignarValoresObjeto} className={errorFolio.folio ? 'p-error' : ''} />
                {errorSerie.serie ? <div><br /> <Message severity="error" text={errorSerie.serie} /> </div> : null}
              </div>
              <div className="p-col-12 p-md-4">
                <br /><br /><br />
                <Button label="Buscar" className="p-button-rounded p-button-warning" onClick={this.buscarSerie} />
              </div>
            </div>
          </AccordionTab>
          <AccordionTab header="Búsqueda por estado de la factura" headerStyle={mostrarOpcionEstado}>
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <Button label="Activo" className="p-button-rounded p-button-warning" onClick={this.buscarFacturaActivo} />
              </div>
              <div className="p-col-12 p-md-4">
                <Button label="Cancelado" className="p-button-rounded p-button-warning" onClick={this.buscarFacturaCancelada} />
              </div>

            </div>
          </AccordionTab>
        </Accordion>
        
        <Dialog header="Mensaje cancelación" visible={this.state.modalResultadoCancelacion} style={{ width: '50vw' }} footer={footer} onHide={this.cerrarmodalConfirmacionCancelacion}>
          <DataTable value={resultadoCfdis} editable={true} scrollable={true} scrollHeight="280px"  >
            <Column field="uuid" header="Mensaje" style={{ width: '600px' }} filter={false} autoLayout={true} />
          </DataTable>
        </Dialog>
        <Card>
          <DataTable value={paginacion.datos} scrollable={true} scrollHeight="280px" responsive={true} autoLayout={true} resizableColumns={true} >
            <Column body={this.actionTemplate} header="Cancelar" style={{ width: '150px' }}/>
            <Column field="twCfdi.uuid" header="Folio fiscal"  style={{ width: '150px' }}/>
            <Column field="twCfdi.total" header="Importe total" style={{ width: '100px' }}/>
            <Column body={this.formatofechaCreacion} header="Fecha creación" style={{ width: '100px' }}/>
            <Column body={this.formatofechaCertificacion} header="Fecha certificación" style={{ width: '100px' }}/>
            <Column body={this.formatofechaCancelacion} header="Fecha cancelación" style={{ width: '100px' }}/>
            <Column field="twCfdi.formaPago" header="Forma Pago" style={{ width: '100px' }}/>
            <Column field="twCfdi.metodoPago" header="Metodo Pago" style={{ width: '100px' }}/>
            <Column body={this.formatoEstatus} header="Estado factura" style={{ width: '100px' }}/>                        
            <Column field="twCfdi.folio" header="Folio" style={{ width: '100px' }}/>
            <Column field="twCfdi.serie" header="Serie" style={{ width: '100px' }}/>
            <Column header="Descargar archivos" body={this.templateDescargaArchivos}  style={{ width: '100px' }}/>
          </DataTable>
          <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina} first={first} onPageChange={this.onPage} rowsPerPageOptions={[20, 40, 60, 80, 100]}></Paginator>
        </Card>
        <Dialog header="Confirmación para cancelar" visible={modalCancelar} modal={true} style={{ width: '30vw' }} onHide={this.cerrarModalCancelacion}>

                    <div className="p-grid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="nombre">Cancelar comprobante: {cancelacionDto.uuid} ?</label>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="cancelacionDto.motivo">Motivo:</label>
                            <Dropdown name="cancelacionDto.motivo" itemTemplate={this.templateMotivos} autoWidth={true} appendTo={document.body} value={cancelacionDto.motivo} options={motivos} 
                                onChange={this.asignarValoresObjeto} placeholder="Selecciona un motivo de cancelacion" className={errores.folioSustitucion ? 'p-error' : ''}/>
                                {errores.motivo ? <div> <Message severity="error" text={errores.motivo} /> </div> : null}
                        </div>

                        <div className="p-col-12 p-md-12">
                            <label htmlFor="cancelacionDto.folioSustitucionustitucion"> Folio Sustitucion</label>
                            <InputText id="cancelacionDto.folioSustitucion" name="cancelacionDto.folioSustitucion" value={cancelacionDto.folioSustitucion || ''} onChange={this.asignarValoresObjeto} className={errores.folioSustitucion ? 'p-error' : ''} />
                            {errores.folioSustitucion ? <div> <Message severity="error" text={errores.folioSustitucion} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="nombre">Click en Salir: No cancelar</label>
                            
                        </div>
                        <div className="p-col-12 p-md-6">
                            <Button label="Cancelar Comprobante" onClick={this.cancelar} className="teal-btn flat-btn" />
                        </div>
                        <div className="p-col-12 p-md-6">
                            <Button label="Salir" onClick={this.cerrarModalCancelacion} className="teal-btn flat-btn" />
                        </div>
                    </div>
                </Dialog>
      </div>

    );
  }

}
export default CancelacionCfdi;